var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClientiAggiungi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.28,
    cy: 45.99,
    r: 45.99
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.6,185.36v-10.2h-10.2c-12.67,0-22.97-10.31-22.97-22.97s10.31-22.97,22.97-22.97h10.2v-6.17c-14.49-11.19-30.05-17.69-43.31-17.69-26.75,0-62.89,26.42-80.67,64.56-6.52,13.99,3.68,30.03,19.12,30.03h110.09c-3.27-3.97-5.23-9.05-5.23-14.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.75,137.55h-18.54v-18.54c0-8.08-6.55-14.64-14.64-14.64h0c-8.08,0-14.64,6.55-14.64,14.64v18.54h-18.54c-8.08,0-14.64,6.55-14.64,14.64h0c0,8.08,6.55,14.64,14.64,14.64h18.54v18.54c0,8.08,6.55,14.64,14.64,14.64h0c8.08,0,14.64-6.55,14.64-14.64v-18.54h18.54c8.08,0,14.64-6.55,14.64-14.64h0c0-8.08-6.55-14.64-14.64-14.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClientiAggiungi);
export default __webpack_public_path__ + "static/media/menu-clienti-aggiungi.634307653a51df8e36cac5636854b367.svg";
export { ForwardRef as ReactComponent };